import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/"); return; }
      try {
        const user = await exchangeSession(m[1]);
        setUser(user);
        // clean hash
        window.history.replaceState({}, document.title, window.location.pathname);
        toast.success(`Welcome, ${user.name?.split(" ")[0] || "friend"}`);
        // If a plan was selected before sign-in, resume on /pricing (which auto-starts checkout)
        let pending = null;
        try { pending = localStorage.getItem("pending_checkout"); } catch {}
        navigate(pending ? "/pricing" : "/", { replace: true, state: { user } });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="label-small">Signing you in…</p>
    </div>
  );
}
